export default "__VITE_ASSET__CDlmgwee__"